import { Layout } from 'antd';
import styled from 'styled-components';

export const WrapperLayout = styled(Layout)`
    width: 100%;
    height: 100%;
    .ant-layout-sider {
        background: #fff;
    }
    .sider-admin {
        width: 260px;
        min-width: 260px;
        max-width: 260px;
        height: 100%;
        position: fixed;
        left: 0;
        top: 60px;
        z-index: 999;
        box-shadow: 0 4px 10px #ddd;
    }
    .sider-admin-collapsed {
        .ant-menu-inline-collapsed {
            width: 100%;
        }
        .ant-menu-inline-collapsed > .ant-menu-item,
        .ant-menu-inline-collapsed
            > .ant-menu-submenu
            > .ant-menu-submenu-title {
            display: flex;
            justify-content: center;
            align-items: center;
            padding-inline: 0 !important;
            gap: 0 !important;
        }
        .ant-menu-inline-collapsed .ant-menu-item-icon {
            margin-inline-end: 0 !important;
            line-height: 0;
        }
        .ant-menu-inline-collapsed .ant-menu-title-content {
            display: none;
        }
    }
    .layout-page-content {
        display: flex;
        flex-direction: column;
        height: 100vh;
        padding: 20px;
        background: #f8f8f8;
        overflow: auto;
        margin: 60px 0 20px 260px;
        min-height: 100vh;
        width: calc(100% - 260px) !important;
    }
    .layout-page-content-collapsed {
        margin-left: 50px;
        margin-top: 15px;
        width: calc(100% - 50px) !important;
    }
`;
